module.exports = __webpack_public_path__ + "img/company1.3ee1fb6c.jpg";